import { useFeatures } from 'modules/core/hooks/useFeatures'

const useHasContractsDataAsJson = (): boolean => {
  const { has_dev_contracts_data_as_json } = useFeatures(['dev_contracts_data_as_json'])
  return has_dev_contracts_data_as_json
}

export default useHasContractsDataAsJson
